export interface IncrementalInputProps {
  name?: string;
  value?: number;
  increment?: IncrementStep;
  min?: number;
  max?: number;
  onChange: (value) => void;
  dataPointer?: string;
  currency?: string;
  locale?: string;
  dataCy?: string;
  decrementBtnTrackingLabel?: string;
  incrementBtnTrackingLabel?: string;
  className?: string;
  label?: string;
  disabled?: boolean;
  invalid?: boolean;
  errorMsgHolderId?: string;
  id?: string;
}

export enum IncrementStep {
  ONE = 1,
  ONE_HUNDRED = 100,
}
